/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { FC, useState } from 'react';
import { BasicInput } from '../../shared/inputs/BasicInput';
import * as yup from 'yup';
import styles from './productPersonaPopup.module.css';
import { BoxedAutoResizeTextarea } from '../../shared/inputs/BoxedAutoResizeTextarea';
import { BasicButton } from '../../shared/buttons/BasicButton';
import Select, { GroupBase, OptionsOrGroups } from 'react-select';
import { usePersonaContext } from '../../../contexts/PersonaContext';
import mixpanel from 'mixpanel-browser';
import { useAuthContext } from '../../../contexts/AuthContext';


interface Props {
  onClose: () => void;
}

export const ProductPersonaSoloPopup: FC<Props> = ({onClose}) => {
  // const [roleValue, setRoleValue] = useState('')
  const [loading, setLoading] = useState(false);
  const [successfulProductSaved, setSuccessfulProductSaved] = useState(false);
  const [value, setValue] = useState<unknown | null>();
  const {saveProduct} = usePersonaContext();
  const {userData} = useAuthContext();


  useEffect(() => {
    if (successfulProductSaved) {
      const resetCopyButtonTextTimeout = setTimeout(() => {
        setSuccessfulProductSaved(false);
      }, 5000);
      return () => clearTimeout(resetCopyButtonTextTimeout);
    }
  }, [successfulProductSaved]);

  const { brandPersonas } = usePersonaContext();
  if (!brandPersonas)
    return (
      <h2>
        🤔 Your team currently has no personas. Create your first brand persona.
      </h2>
    );
  if (brandPersonas.length === 0) {
    return (
      <h2>
        🤔 Your team currently has no personas. Create your first brand persona.
      </h2>
    );
  }

  interface Option {
    readonly label: string;
    readonly value: string;
  }

  const optionlist: OptionsOrGroups<Option, GroupBase<Option>> | undefined[] =
    brandPersonas.map((brand) => {
      return {
        value: brand.id,
        label: brand.brand,
      };
    });

  const ProductPersonaSchema = yup.object({
    product: yup.string().required('Please enter a product name.'),
    description: yup.string().required('Please describe the product.'),
  });

  return (
    <>
      <Formik
        initialValues={{
          product: '',
          brand: '',
          description: '',
          // brandID: '',
          // brandName: '',
        }}
        onSubmit={async (values) => {
          setLoading(true);
          //rename these
          const brand = value? value: '';
          const  product= values.product;
          const  description= values.description;
          await saveProduct({brand, product, description,})
          mixpanel.track('Product Persona Saved', {
            product: product,
            response: {brand, product, description},
            email: userData?.email,
            displayName: userData?.displayName,
          });
          setLoading(false);
          setSuccessfulProductSaved(true);
          onClose();
        }}
        validationSchema={ProductPersonaSchema}
      >
        {(props) => {
          return (
            <>
            <div className={styles['form-popup']}>
             <div className={styles['header']}>
              <h3>Name your Product</h3>
              </div>
              <div className={styles['input-container']}>
              <div className={styles['text-area']}>
                <BasicInput
                  id="product-persona-input"
                  disabled={false}
                  placeholder="Nike Air Force 1"
                  setValue={props.handleChange('product')}
                  touched={props.touched.product ? true : false}
                  onBlur={props.handleBlur}
                  value={props.values.product}
                />
                </div>
              </div>
              <div className={styles['input-container']}>
                <div className={styles['header2']}>
              <h3>What brand does this product belong to?</h3>
                </div>
              <div className={styles['text-area']}>
                <div className={styles['creatable']}>
                <Select
                  onChange={(newValue) => setValue(newValue)}
                  options={optionlist}
                  inputValue={''}
                  value={value}
                />
                </div>
                </div>
              </div>
              <div className={styles['input-container']}>
              <div className={styles['header2']}>
              <h3>Describe the product.</h3>
              </div>
              <div className={styles['text-area']}>
              <BoxedAutoResizeTextarea
                id="product-persona-input"
                placeholder="The radiance lives on in the Nike Air Force 1 ’07, the b-ball OG that puts a fresh spin on what you know best: durably stitched overlays, clean finishes and the perfect amount of flash to make you shine."
                value={props.values.description}
                setValue={props.handleChange('description')}
                disabled={loading}
                errors={props.errors.description as string}
                touched={props.touched.description ? true : false}
                onBlur={props.handleBlur}
              />
                </div>
              </div>
              <div className={styles['input-container']}>
              <div className={styles['button-area']}>
              <BasicButton
                type="button"
                theme="dark"
                loading={loading}
                disabled={successfulProductSaved}
                image={{
                  src: '/icons/Playlist.svg',
                  height: 14,
                  width: 14,
                }}
                text={successfulProductSaved ? 'Product Saved!' : 'Save Persona'}
                onClick={() => props.handleSubmit()}
              />
              </div>
              </div>
              </div>
            </>
          );
        }}
      </Formik>
    </>
  );
};
